import { Component, OnInit } from "@angular/core";
import { IncomeReportService } from "./income-report.service";
import moment from 'moment';
import { Report } from '../../report';

@Component({
  selector: 'app-income-report',
  templateUrl: './income-report.component.html',
  styleUrls: ['./income-report.component.scss']
})

export class IncomeReportComponent implements OnInit {
  public totalEntries: number = 0;
  public data: any[] = [];
  public limit: number = 0;

  public tableColumns: string[] = [
    "name",
    "amount",
    "count"
  ];

  public displayTableColumns = {
    name: "Name",
    amount: "Amount",
    count: "Count",
  };

  public totalNumberOfRecords: number = 0;
  public incomeReportData: any[] = [];

  public requestBody: Report = {};
  loading = false;

  // selection = new SelectionModel<TransactionModel>(true, []);

  constructor(
    public reportService: IncomeReportService
  ) {
  }

  async ngOnInit() {
    this.reportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };

    this.requestBody.filterOptions = {
      createdAt: {
        // @ts-ignore
        startDate: moment().startOf('day').toISOString(),
        // @ts-ignore
        endDate: moment().endOf('day').toISOString(),
      }
    };

    await this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.reportService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.reportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = { searchKey: event };
    } else {
      this.requestBody.searchOptions = undefined;
      this.reportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.reportService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.reportService.activateLoader();
    this.reportService.setParams(this.requestBody);
    const report = await this.reportService.make();
    this.incomeReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
}
